// Phone/tablet bottom bar for the full-screen builders (KAN-763). The white
// footer comes from the SAME source every wizard uses (`wizardFooterStyle`) so
// the bar never differs in shade from a modal footer; it is tighter at the
// bottom (the larger of the 12px gutter and the safe-area inset). Tablet holds the inner row to the form
// column's width; phone is full width. Desktop renders it only for the
// no-rail step (the rail's submit block owns the total and the primary on the
// steps that have one), with `maxWidth` set to the single column.
import { foundation } from '../../../ui';
import { wizardFooterStyle } from '../routeOverride/transferWizardStyles';
import { LOGJOB_COLUMN_MAX_WIDTH } from '../../../pages/logJobLayoutStyles';

/**
 * Bottom padding = the larger of the 12px gutter and the device safe-area
 * inset (the home indicator already gives the breathing room; adding 16px on
 * top of it left a tall empty band under the buttons).
 */
export const FULLSCREEN_BAR_PADDING_BOTTOM = `max(${foundation.spacePx[3]}, env(safe-area-inset-bottom, 0px))`;

const bar = {
  flexShrink: 0,
  // Sides come from the wizard footer (one source, never drifts); top 12px;
  // the bottom is the safe-area rule above.
  padding: wizardFooterStyle.padding,
  paddingTop: foundation.spacePx[3],
  paddingBottom: FULLSCREEN_BAR_PADDING_BOTTOM,
  borderTop: wizardFooterStyle.borderTop,
  background: wizardFooterStyle.background,
  boxSizing: 'border-box',
  width: '100%',
};
const inner = { width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column' };

/**
 * @param {object} props
 * @param {'phone'|'tablet'|'desktop'} props.layout
 * @param {number} [props.maxWidth] - hold the inner row to this width (px); tablet defaults to the form column's.
 * @param {string} [props.testId]
 */
export default function FullScreenBottomBar({ layout, maxWidth, children, testId = 'fullscreen-flow-bottom-bar' }) {
  const rowMax = maxWidth ?? (layout === 'tablet' ? LOGJOB_COLUMN_MAX_WIDTH : null);
  return (
    <div style={bar} data-testid={testId} data-layout={layout} data-cvx-overlay-bar={layout === 'desktop' ? undefined : ''}>
      <div style={rowMax ? { ...inner, maxWidth: `${rowMax}px` } : inner}>
        {children}
      </div>
    </div>
  );
}
